import addMinutes from 'date-fns/esm/addMinutes';
import isAfter from 'date-fns/esm/isAfter';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { dealerActionCreators, DealerActionKeys, FetchDealerOpenOrders } from '..';
import { IState } from '../..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { fetchOpenOrders } from '../dealerApi';

function* fetchDealerOpenOrdersSaga(action: FetchDealerOpenOrders) {
  const validForMinutes = 15;
  let shouldReload = true;
  const current: { loadedAt: Date; amount: number } | undefined = yield select(
    (state: IState) => state.dealer.openOrders[action.payload.accountNum]
  );

  if (current) {
    const endTime = addMinutes(current.loadedAt, validForMinutes);

    if (isAfter(endTime, new Date())) {
      shouldReload = false;
    }
  }

  if (shouldReload) {
    yield put(dealerActionCreators.toggleLoading({ accountNum: action.payload.accountNum, type: 'openOrders' }));

    const response: IApiExecuteRespone<{ accountNum: string; amount: number }> = yield call(
      fetchOpenOrders,
      action.payload.accountNum
    );

    if (response.requestFailed) {
      yield showFailedRequestDialog(response);
    } else if (response.value) {
      yield put(dealerActionCreators.setOpenOrders(response.value));
    }

    yield put(dealerActionCreators.toggleLoading({ accountNum: action.payload.accountNum, type: 'openOrders' }));
  }
}

export function* watchFetchDealerOpenOrders() {
  yield takeEvery(DealerActionKeys.FETCH_DEALER_OPEN_ORDERS, fetchDealerOpenOrdersSaga);
}
